import styled from 'styled-components'

export default styled.div`
  width: 1px;
  align-self: stretch;
  background: ${props => props.theme.colors.border.default};
`
